import { render, staticRenderFns } from "./ClinicalExposure.vue?vue&type=template&id=662e713a&scoped=true&"
import script from "./ClinicalExposure.vue?vue&type=script&lang=js&"
export * from "./ClinicalExposure.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalExposure.vue?vue&type=style&index=0&id=662e713a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e713a",
  null
  
)

export default component.exports